import { HttpErrorResponse } from '@angular/common/http';

export class LoginTimeoutError extends Error {
    httpStatus = 440;
    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, LoginTimeoutError.prototype);
    }
}
